import { pseudoDescriptors } from "./pseudoDescriptors";
const mergeProps = (a, b, leaveOutClassNames = false, inverseShorthands) => {
  const out = {};
  const outCns = leaveOutClassNames ? {} : null;
  for (const key in a) {
    mergeProp(out, outCns, a, b, key, leaveOutClassNames, inverseShorthands);
  }
  if (b) {
    for (const key in b) {
      mergeProp(out, outCns, b, void 0, key, leaveOutClassNames, inverseShorthands);
    }
  }
  return [out, outCns];
};
function mergeProp(out, outCns, a, b, key, leaveOutClassNames, inverseShorthands) {
  const val = a[key];
  const shorthand = (inverseShorthands == null ? void 0 : inverseShorthands[key]) || null;
  if (key in pseudoDescriptors) {
    out[key] = {
      ...out[key],
      ...val
    };
    return;
  }
  if (b && (key in b || shorthand && shorthand in b)) {
    return;
  }
  if (shorthand) {
    key = shorthand;
  }
  if (leaveOutClassNames && (val == null ? void 0 : val[0]) === "_") {
    outCns[key] = val;
  } else {
    out[key] = val;
  }
}
export {
  mergeProps
};
//# sourceMappingURL=mergeProps.js.map
